import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [isApprover, setIsApprover] = useState(!!user?.is_approver);
  const [loading, setLoading] = useState(false);

  const save = async () => {
    setLoading(true);
    try {
      const { data } = await api.patch("/users/me", { name, email, is_approver: isApprover });
      setUser(data);
      toast.success("Profile updated");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6 animate-fade-up max-w-lg">
      <header>
        <p className="text-amber text-xs uppercase tracking-[0.18em] font-medium mb-2">Account</p>
        <h1 className="font-serif text-3xl">Profile</h1>
      </header>

      <div className="tablo-card p-5 space-y-4">
        <div>
          <label className="text-xs uppercase tracking-wider text-light-ink mb-1 block">Phone</label>
          <Input value={user?.phone || ""} disabled className="bg-cream border-tablo-border" data-testid="profile-phone-disabled" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-light-ink mb-1 block">Name</label>
          <Input value={name} onChange={(e) => setName(e.target.value)} className="bg-white border-tablo-border" data-testid="profile-name-input" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-light-ink mb-1 block">Email</label>
          <Input value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white border-tablo-border" data-testid="profile-email-input" />
        </div>
        {user?.org_name && (
          <div className="text-sm text-light-ink">
            <p>Org: <span className="font-medium text-ink">{user.org_name}</span></p>
            <p>GSTIN: <span className="font-medium text-ink">{user.gstin || "—"}</span></p>
          </div>
        )}
        <div className="flex items-center justify-between pt-2">
          <div>
            <p className="text-sm font-medium">HR Approver</p>
            <p className="text-xs text-light-ink">See your team's requests in the Approvals tab.</p>
          </div>
          <Switch checked={isApprover} onCheckedChange={setIsApprover} data-testid="profile-approver-switch" />
        </div>
      </div>

      <Button onClick={save} disabled={loading} className="w-full tablo-btn-primary" data-testid="profile-save-btn">
        {loading ? "Saving..." : "Save changes"}
      </Button>
    </div>
  );
}
